<template>
    <div>
        <div class="box">
            <div class="columns">
                <div class="column is-half">
                    <project-configuration-fields v-model="value" />
                </div>
                <div class="column is-half has-text-left">
                    <project-configuration-privacy v-model="value" />
                </div>
            </div>
        </div>
        <div class="notification is-link" style="margin: 10px 0">
            <span class="level">
                <p>Define the project configuration</p>
                <button
                    v-t="'configure'"
                    class="lb-button has-text-link is-uppercase"
                />
            </span>
        </div>
    </div>
</template>

<script>
import ProjectConfigurationFields from '@/components/ProjectConfigurationFields';
import ProjectConfigurationPrivacy from '@/components/ProjectConfigurationPrivacy';
import { PRIVACY_OPTIONS, PERMISSION_OPTIONS } from '@/lib/constants';
export default {
    components: {
        ProjectConfigurationFields,
        ProjectConfigurationPrivacy,
    },
    props: {
        value: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    data() {
        return {
            privacyOptions: PRIVACY_OPTIONS,
            permissionOptions: PERMISSION_OPTIONS,
        };
    },
};
</script>

<style></style>
